import { FC } from "react";
import { Box } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useSearchParams } from "react-router-dom";
import { useEffectOnceWhen } from "rooks";
import { useAppSelector } from "@/store/hooks";
import { dimensionCategoriesLengthSelector } from "@/store/dimensions/selectors/slice-data/categories/dimensionCategoriesLengthSelector";
import {
  CategoryCostAllocationTabItem,
  CategorySharedCostTabType,
} from "@/components/pages/dimensions/components/form-drawer/components/dimension/category-cost-allocation-tabs/CategoryCostAllocationTabItem";
import { dimensionSharedCostsLengthSelector } from "@/store/dimensions/selectors/slice-data/shared-costs/dimensionSharedCostsLengthSelector";
import { dimensionEditActiveTab } from "@/components/pages/dimensions/components/form-drawer/components/dimension/utils/constants";

interface CategoryCostAllocationTabsProps {
  view: CategorySharedCostTabType;
  setView(v: CategorySharedCostTabType): void;
}

export const CategoryCostAllocationTabs: FC<
  CategoryCostAllocationTabsProps
> = ({ view, setView }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeViewFromSearchParams = searchParams.get(
    dimensionEditActiveTab,
  ) as CategorySharedCostTabType;

  const categoriesCount = useAppSelector(dimensionCategoriesLengthSelector);
  const allocationsCount = useAppSelector(dimensionSharedCostsLengthSelector);

  useEffectOnceWhen(() => {
    setView(activeViewFromSearchParams);
    searchParams.delete(dimensionEditActiveTab);
    setSearchParams(searchParams);
  }, !!activeViewFromSearchParams);

  return (
    <Stack
      p={1}
      border={1}
      bgcolor="white"
      borderRadius={2}
      borderColor="grey.300"
    >
      <Box
        bgcolor="grey.200"
        border={2}
        borderColor="grey.200"
        width="fit-content"
        borderRadius={1}
        overflow="hidden"
      >
        <CategoryCostAllocationTabItem
          view="category"
          setView={setView}
          label="Categories"
          count={categoriesCount}
          selected={view === "category"}
        />

        <CategoryCostAllocationTabItem
          setView={setView}
          view="sharedCost"
          disabled={!categoriesCount}
          label="Cost Allocation"
          count={allocationsCount}
          selected={view === "sharedCost"}
        />
      </Box>
    </Stack>
  );
};
